module.exports = "data:image/svg+xml,export default __webpack_public_path__ + '6979173432f39d2c8526c6f5a341434e.svg';"